import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import userReportService from './userReportService'

const initialState = {
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: '',
}

export const reportUnmappedRoute = createAsyncThunk('userReport/unmappedRoute', async (routeDetails, { getState, rejectWithValue }) => {
    try {
        const token = getState().auth.user.token;
        return await userReportService.reportUnmappedRoute(routeDetails, token);
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || error.message || error.toString());
    }
})

export const reportMissingStation = createAsyncThunk('userReport/missingStation', async (stationDetails, { getState, rejectWithValue }) => {
    try {
        const token = getState().auth.user.token;
        return await userReportService.reportMissingStation(stationDetails, token);
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || error.message || error.toString());
    }
})

export const reportMessage = createAsyncThunk('userReport/message', async (messageDetails, { getState, rejectWithValue }) => {
    try {
        const token = getState().auth.user.token;
        return await userReportService.reportMessage(messageDetails, token);
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || error.message || error.toString());
    }
})

export const userReportSlice = createSlice({
    name: 'userReport',
    initialState,
    reducers: {
        reset: (state) => initialState
    },
    extraReducers: (builder) => {
        builder
            .addCase(reportUnmappedRoute.pending, (state) => {
                state.isLoading = true
                state.isSuccess = false
                state.isError = false
            })
            .addCase(reportUnmappedRoute.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.isError = false
            })
            .addCase(reportUnmappedRoute.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.isSuccess = false
                state.message = action.payload
            })

            .addCase(reportMissingStation.pending, (state) => {
                state.isLoading = true
                state.isSuccess = false
                state.isError = false
            })
            .addCase(reportMissingStation.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.isError = false
            })
            .addCase(reportMissingStation.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.isSuccess = false
                state.message = action.payload
            })

            .addCase(reportMessage.pending, (state) => {
                state.isLoading = true
                state.isSuccess = false
                state.isError = false
            })
            .addCase(reportMessage.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.isError = false
            })
            .addCase(reportMessage.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.isSuccess = false
                state.message = action.payload
            })
    }
})

export const { reset } = userReportSlice.actions
export default userReportSlice.reducer